<template>
	<div class="parent">
		<p style="font-size:30px; margin:10px;">{{title}}</p>

		<div v-if="perms.includes(edit_perm)" class="edit-bar">
			<div v-if="isEdit==true">
				<button v-on:click="cancel()">Cancel</button>
				<button v-on:click="save()">Save</button>
				<button v-if="isAdd==true" v-on:click="add()">Add</button>
			</div>
			<div v-else>
				<button v-on:click="edit()">Edit</button>
			</div>
		</div>

		<div id="editTable" key="updateKey" class="scroll" v-bind:style="navbar?'margin-bottom:50px':'margin-bottom:10px'">
			<table style="position:relative; z-index:1">
				<thead>
					<tr>
						<th v-if="isEdit==true">
							Clear
						</th>
						<th v-for="(name) in column_names">
							{{name}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(column, i) in column_data">
						<td style="width:30px" v-if="isEdit==true">
							<button style="width:30px" v-on:click="clearRow(i)"><font-awesome-icon icon="times" /></button>
						</td>
						<td v-for="(data, j) in column">
							<div v-if="edit_types[j] == null">
								{{data}}
							</div>
							<div v-else-if="edit_types[j] == 'DateTime'">
								<div v-if="isEdit==true">
									<datetime
									v-model="edit_data[i][j]"
									style="width:100%"
									/>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
							<div v-else-if="edit_types[j] == 'Value'">
								<div v-if="isEdit==true">
									<input
									v-if="checkBinds(i,j)"
									autocomplete="off"
									type="text"
									v-model="edit_data[i][j]"
									style="width:100%"
									/>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
							<div v-else-if="edit_types[j] == 'TextArea'">
								<div v-if="isEdit==true">
									<textarea
									v-if="checkBinds(i,j)"
									v-model="edit_data[i][j]"
									style="width:500px; min-height:50px;"
									/>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
							<div v-else-if="edit_types[j] == 'Employee'">
								<div v-if="isEdit==true">
									<autocomplete
									v-model=edit_data[i][j]
									:type="16"
									style="width:100%"
									>
									</autocomplete>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
							<div v-else-if="edit_types[j] == 'LocalOffice'">
								<div v-if="isEdit==true">
									<autocomplete
									v-model=edit_data[i][j]
									:type="65"
									style="width:100%"
									>
									</autocomplete>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
							<div v-else-if="edit_types[j] == 'EmployeeStatus'">
								<div v-if="isEdit==true">
									<autocomplete
									v-model=edit_data[i][j]
									:type="1"
                                    :list="['active','inactive']"
									style="width:100%"
									>
									</autocomplete>
								</div>
								<div v-else>
									{{data}}
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
import Vue from 'vue'
export default {
    props: {
        id: Number,
		navbar:Boolean,
		title:'',
		term: '',
		edit_types:Array,
		edit_perm:Number,
		binds:{
			type:Array,
			required:false,
			default:[]
		},
		isAdd:{
			type:Boolean,
			required:false,
			default:false
		},
		addDefault:{
			type:Array,
			required:false,
			default:null
		},
    },
	data() {
		return {
			perms:[],
			column_names: [],
			column_data:[],
			edit_data: [],
			isEdit:false,
			intervalID:'',
            updateKey:0,
		}
	},
	async created () {
		this.perms = api.getPerms();

		this.getTables()
		this.autoReload()
	},
	methods: {
		autoReload(){
			this.intervalID = setInterval(function(){
                if(!this.isEdit) {
				    this.getTables()
                }
			}.bind(this), 5000);
		},
		setData(index, value){
			var i = parseInt(index / this.column_data[0].length);
			var j = parseInt(index % this.column_data[0].length);
			this.edit_data[i][j] = value;
		},
		getTables (){
			api.postData(
				{
					type:"add",
					data:{
						pageid:this.id,
						term:this.term,
					}
				}
			).then((res) => {
				if(res.data.data.column_data)
					this.column_data = res.data.data.column_data;
				this.column_names = res.data.data.column_names;
                this.updateKey++;
			});
        },
		add(){
            if(this.addDefault!=null) {
                this.column_data.push(this.addDefault)
                this.edit_data.push(this.addDefault)
                this.updateKey++;
                this.scrollToBottom()
            }else {
                api.postData(
                    {
                        type:"insert",
                        data:{
                            add:true,
                            pageid:this.id,
                            data:this.edit_data,
                            term:this.term,
                        }
                    }
                ).then((res) => {
                    this.scrollToBottom()
                });

                this.column_data = this.edit_data.map(arr => arr.slice());
                this.isEdit=false
                this.updateKey++;
                this.getTables()
            }
		},
        save(){
			api.postData(
				{
					type:"insert",
					data:{
						add:false,
						pageid:this.id,
						data:this.edit_data,
						term:this.term,
					}
				}
			).then((res) => {
                this.scrollToBottom()
                this.updateKey++;
                this.getTables()
			});

			this.column_data = this.edit_data.map(arr => arr.slice());
			this.isEdit=false
        },
		cancel(){
			this.isEdit=false
            this.updateKey++;
			this.getTables()
        },
		edit(){
			this.isEdit=true
            this.updateKey++;
			this.edit_data = this.column_data.map(arr => arr.slice());
		},
		checkBinds(col, row){
			if(this.binds.includes(row)){
				for(let i = 0;i<this.binds.length;i++){
					if(this.binds[i]!=row){
						if(this.edit_data[col][this.binds[i]]==null || this.edit_data[col][this.binds[i]]==''){
							return false
						}
					}
				}
			}
			return true
		},
		clearRow(row){
            if(this.addDefault!=null && this.edit_data[row][0]==this.addDefault[0]) {
                this.edit_data.splice(row, 1)
                this.column_data.splice(row, 1)
            }else{
                for(let i = 0;i<this.edit_types.length;i++){
                    if(this.edit_types[i]!=null){
                        Vue.set(this.edit_data[row], i, '')
                    }
                }
            }
		},
        scrollToBottom(){
            requestAnimationFrame(() => {
                var scroll = document.getElementById("editTable");
                scroll.scrollTo(0, scroll.scrollHeight);
            });
        }
	},
    beforeDestroy() {
        // Clear the interval when the component is destroyed
        clearInterval(this.intervalID);
    },
}
</script>

<style scoped>
table {
	border-collapse: collapse;
}
td, th {
	border-spacing: 0;
}
.edit-bar {
	margin:10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_7.vue